import React from 'react';
import LocationTemplate from './LocationTemplate';

const CoatsPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Coats"
      stateName="North Carolina"
      countyName="Harnett"
      zipCodes={["27521"]}
      latitude={35.4076}
      longitude={-78.6706}
      population={2467}
      historicalFact="Named after William Coats, an early settler and landowner in the area."
      nearbyTowns={[
        "Dunn, NC",
        "Benson, NC",
        "Erwin, NC",
        "Angier, NC",
        "Lillington, NC",
        "Buies Creek, NC",
        "Four Oaks, NC",
        "Newton Grove, NC"
      ]}
    />
  );
};

export default CoatsPage;